import { View, Text, Image } from '@react-pdf/renderer';
import type { Period } from '@weft/types';
import dayjs from 'dayjs';
import React from 'react';

type HeaderProps = {
  invoiceId: string;
  billingCycle: Period;
  accountName: string;
  customerName: string;
};

export const Header: React.FC<HeaderProps> = ({ invoiceId, billingCycle, accountName, customerName }) => {
  const invoiceMonth = dayjs(billingCycle.startTime).format('MMMM YYYY');
  const isAu10tix = accountName === 'Au10tix';

  const imageName = isAu10tix ? 'aut10ix-logo' : 'Earth';

  return (
    <View
      style={{ paddingTop: '6px' }}
    >
      <View
        style={{
          borderBottomWidth: '1px',
          borderBottomColor: '#E8F2F8',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          columnGap: '17px',
          paddingBottom: '6px',
        }}
      >
        <Image
          style={{
            width: '52px',
          }}
          src={`${window.location.origin}/assets/images/${imageName}.png`}
        />
        
        <View style={{ marginVertical: '6px' }}>
          <Text style={{
            fontSize: '14px',
            fontWeight: 500,
          }}
          >
            {accountName}
          </Text>
        </View>
      </View>

      <View
        style={{
          borderBottomWidth: '1px',
          borderBottomColor: '#E8F2F8',
          paddingVertical: '17px',
          fontSize: '22px',
          fontWeight: 500,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'baseline',
          justifyContent: 'flex-start',
          columnGap: '9px',
        }}
      >
        <Text>{`${invoiceMonth} report`}</Text>
        <Text style={{
          color: '#9D9D9D',
          fontSize: '10px',
          fontWeight: 400,
          textTransform: 'uppercase',
        }}
        >
          {`#${getFormattedId(invoiceId)}`}
        </Text>
      </View>

      <View
        style={{
          borderBottomWidth: '1px',
          borderBottomColor: '#E8F2F8',
          paddingVertical: '17px',
          fontSize: '22px',
          fontWeight: 500,
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
          justifyContent: 'flex-start',
          columnGap: '9px',
        }}
      >
        <Text style={{
          fontSize: '10px',
          color: '#6D6D6D',
          fontWeight: 400,
        }}
        >
          To:
        </Text>
        <Text style={{
          fontSize: '15px',
          fontWeight: 600,
        }}
        >
          {customerName}
        </Text>
      </View>
    </View>
  );
};

const getFormattedId = (id: string, charCount = 5) => {
  const digits = -Math.abs(charCount);

  return id.slice(digits);
};